module.exports = __webpack_public_path__ + "img/notepad.f6c45ad3.svg";